export const componentPalette = {
  primary: "#009989",
  secondary: "#e1f1ef",
  fontSize: 12,
  hover: "#008080",
  error: "#DD5931",
  black: "#000000",
  yellow: "#f2db7d",
  purple: "#313183",
  red: "#FF0000",
  redWarning: "#DCB1A0",
  grey: "#D9D9D9",
  lightgrey: "lightgrey",
  blueGrey: "#64748B",
  white: "#FFFFFF",
  redSecond: "#b83819",
  redThird: "#AB2221",
  redFourth: "#d26f6f",
  redFifth: "#e99898",
  redPeriodDate: "#f3cdbe",
  disabled: "rgba(0, 0, 0, 0.04)",
  excelColor: "#3D8A58",
  pdfColor: "#CD524A",
  wordColor: "#066EBF",
  pptxColor: "#F8460D",
  greenChart: "#32c318",
  redChart: "#f90000",
  mainMyTask: "#FA8C16",
  secondMyTask: "#FFC485",
};
